import { render, staticRenderFns } from "./CustomerCustomerEmail.vue?vue&type=template&id=13a4abde"
import script from "./CustomerCustomerEmail.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports